import { ObjectRepository } from '@framework/repository';
import { RTDBPath } from 'balus-common';
import { UserEntity } from './UserEntity';
import type { UserId, UserJSON } from 'balus-common';

type UserEntityRepository = ObjectRepository<UserJSON, UserEntity>;

export const createUserEntityRepository = (userId: UserId): UserEntityRepository => {
  return new ObjectRepository(UserEntity, RTDBPath.User.userEntityPath(userId));
};
